import { Element, Node } from "@siteimprove/alfa-dom";
import { Predicate } from "@siteimprove/alfa-predicate";
import { isFlexContainer } from "../../predicate/is-flex-container.js";
import { isGridContainer } from "../../predicate/is-grid-container.js";
import { Style } from "../../style.js";
const { or } = Predicate;
export function isFlexOrGridChild(device, context) {
    return (element) => element
        .parent(Node.fullTree)
        .filter(Element.isElement)
        .some((parent) => or(isFlexContainer, isGridContainer)(Style.from(parent, device, context)));
}
//# sourceMappingURL=is-flex-or-grid-child.js.map